var _rect, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNumberWidget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 94,
    viewBox: "0 0 183 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.212402,
    y: 0.514893,
    width: 182.749,
    height: 12.6733,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.212402,
    y: 27.4456,
    width: 113.43,
    height: 12.6733,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.713 93.7122C8.37966 93.7122 6.67166 92.8256 5.58899 91.0522C4.52499 89.2789 3.99299 86.7962 3.99299 83.6042C3.99299 80.4122 4.52499 77.9296 5.58899 76.1562C6.67166 74.3829 8.37966 73.4962 10.713 73.4962C13.0463 73.4962 14.745 74.3829 15.809 76.1562C16.8917 77.9296 17.433 80.4122 17.433 83.6042C17.433 86.7962 16.8917 89.2789 15.809 91.0522C14.745 92.8256 13.0463 93.7122 10.713 93.7122ZM10.713 91.6682C11.4783 91.6682 12.1317 91.5096 12.673 91.1922C13.2143 90.8749 13.653 90.4269 13.989 89.8482C14.325 89.2696 14.5677 88.5882 14.717 87.8042C14.885 87.0202 14.969 86.1522 14.969 85.2002V82.0082C14.969 81.0562 14.885 80.1882 14.717 79.4042C14.5677 78.6202 14.325 77.9389 13.989 77.3602C13.653 76.7816 13.2143 76.3336 12.673 76.0162C12.1317 75.6989 11.4783 75.5402 10.713 75.5402C9.94766 75.5402 9.29432 75.6989 8.75299 76.0162C8.21166 76.3336 7.77299 76.7816 7.43699 77.3602C7.10099 77.9389 6.84899 78.6202 6.68099 79.4042C6.53166 80.1882 6.45699 81.0562 6.45699 82.0082V85.2002C6.45699 86.1522 6.53166 87.0202 6.68099 87.8042C6.84899 88.5882 7.10099 89.2696 7.43699 89.8482C7.77299 90.4269 8.21166 90.8749 8.75299 91.1922C9.29432 91.5096 9.94766 91.6682 10.713 91.6682ZM21.5661 93.3762V91.3042H27.0261V75.5682H26.8301L21.9021 80.1602L20.5301 78.6762L25.7101 73.8322H29.3781V91.3042H34.4181V93.3762H21.5661Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNumberWidget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/number-widget.7e6b4efa0718b7de74166cec2c63a6d0.svg";